// validators/shared.js
export const sharedValidators = {
  title: (step, { step1 }, t) =>
    step === 2 && !step1.name?.trim() ? t("please_fill_title") : null,
  
  location: (step, { step1 }, t) => {
    if (step !== 4) return null;
    if (!step1.city_id) return t("please_fill_city");
    if (!step1.phone?.trim()) return t("please_fill_phone");
    if (!step1.address?.trim()) return t("please_fill_address");
    return null;
  },

  summary: (step, { step2 }, t) => {
    if (step !== 8) return null;
    if (!step2.short_summary?.trim()) return t("please_fill_summary");
    if (step2.short_summary.trim().length < 32) return t("summary_too_short");
    return null;
  },

  description: (step, { step2 }, t) => {
    if (step !== 8) return null;
    if (!step2.detailed_description?.trim())
      return t("please_fill_description");
    if (step2.detailed_description.trim().length < 60)
      return t("description_too_short");
    return null;
  },

  keyPoints: (step, { step2 }, t) =>
    step === 8 && !step2.key_points[0]?.trim()
      ? t("please_fill_key_points")
      : 
      null,

  keywords: (step, { step2 }, t) =>
    step === 10 && (!step2.keyword || step2.keyword.length === 0)
      ? t("please_select_keywords")
      : null,

  images: (step, { step2 }, t) =>
    // step === 12 && (!step2.images || step2.images.length < 1)
    //   ? t("please_add_image")
    //   :
       null,

  // cutoffTime: (step, { step3 }, t) =>
  //   step === 14 &&
  //   (!step3.cutoff_time_booking_value || step3.cutoff_time_booking_value < 1)
  //     ? t("please_fill_cutoff_time")
  //     : null,

  dateRange: (step, { step3 }, t) => {
    if (step !== 13) return null;
    if (!step3.start_date) return t("please_fill_start_date");
    if (!step3.end_date) return t("please_fill_end_date");
    return null;
  },

  cancellationPolicy: (step, { step3 }, t) =>
    step === 13 && step3.cancellation_policy_id == null
      ? t("please_fill_cancellation_policy_id")
      : null,

  bookingConfirmation: (step, { step3 }, t) =>
    step === 14 && !step3.booking_confirmation_mode
      ? t("please_fill_booking_confirmation_mode")
      : null,

  applicableDays: (step, { step3 }, t) =>
    step === 15 && step3.pricing.applicable_days.length === 0
      ? t("please_fill_applicable_days")
      : null,
};
